module.exports = __webpack_public_path__ + "static/nldc2019-logo-black-54a2c2999235edd0a79255ac99484387.png";